import { connect } from 'react-redux';
import { IState } from '../../store';
import { DealRentButton } from './DealRentButton';
import { prefetchFormState } from '../../store/deal-rent';
import { isDealRentActionTitle } from '../../utils/dealRentTitleExperiment';

export function mapStateToProps(state: IState) {
  const offer = state.offerData.offer;
  const isAvailable =
    Boolean(offer.flags && offer.flags.isDealRent && offer.dealType === 'rent') && !state.entryToShowEnabled;
  const buttonTitle = isDealRentActionTitle(state.experiments) ? 'Отправить анкету' : 'Назначить просмотр';

  return {
    isAvailable,
    isLoading: state.dealRent.isPrefetching,
    buttonTitle,
  };
}

export const DealRentButtonContainer = connect(mapStateToProps, { open: prefetchFormState })(DealRentButton);
